import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';
import { LoginComponent } from './pages/login/login.component';
import { BusinessComponent } from './pages/business/business.component'
import { HelpComponent } from './pages/help/help.component'
import { SuccessPageComponent } from './pages/success-page/success-page.component'
import { VersionComponent } from './pages/version/version.component'

const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  { path: 'home', component: LandingComponent },
  { path: 'login', component: LoginComponent},
  { path: 'business-details', component: BusinessComponent},
  { path: 'help', component: HelpComponent},
  { path: 'success-page', component: SuccessPageComponent },
  { path: 'version', component: VersionComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}
